/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from "react";
import "./GestionDroits.scss";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import BtnBlanc from "Components/Boutons/BtnBlanc/btn-blanc";
import { FaEye, FaRegEdit } from "react-icons/fa";
import AttribuerDroits from "./AttribuerDroits/AttribuerDroits";
import GestionDiffuseurs from "./GestionDiffuseurs/GestionDiffuseurs";
import EntreprisesPartenaires from "./EntreprisesPartenaires/EntreprisesPartenaires";
import Contributeurs from "./Contributeurs/Contributeurs";
import { InputText } from "primereact/inputtext";
import { HiSearch } from "react-icons/hi";
import { Dropdown } from "primereact/dropdown";
import { useFetchGet } from "Services/api";

/**
 * Permet d'afficher la page de gestion des droits
 * Page accessible uniquement pour les administrateurs
 */
// TO DO : récupérer les bons rôles de l'api et la date d'expiration
// TO DO : accéder à la date de dernière connexion, de création de compte
const GestionDroits = (props) => {
  const [page1, setPage1] = useState(true);
  const [activeIndex, setActiveIndex] = useState(0);
  const [filtreMotsCles, setFiltreMotsCles] = useState("");
  const [isFilteringKeyword, setIsFilteringKeyword] = useState(false);
  const [orderPartner, setOrderPartner] = useState(null);
  const orderData = [
    { label: "Par défaut", value: "Default" },
    { label: "Partenaires", value: "Partner" },
    { label: "Autres", value: "Not Partner" },
  ];

  // *****************************************************************
  // ************************ Constantes *****************************
  // *****************************************************************
  // Label des boutons de gauche
  const buttonsNav = [
    "Attribuer et voir les droits",
    "Gérer le flux des diffuseurs",
    "Identifier les entreprises partenaires",
  ];
  const dataRoles = useFetchGet("/roles", props.auth.token);
  const [rolesFromDb, setRolesFromDb] = useState([]);
  useEffect(() => {
    dataRoles.loaded && setRolesFromDb(dataRoles.data);
  }, [dataRoles.loaded]);
  const getComponents = () => {
    switch (activeIndex) {
      case 0:
        return page1 ? (
          <AttribuerDroits rolesFromDb={rolesFromDb} />
        ) : (
          <Contributeurs rolesFromDb={rolesFromDb} />
        );
      case 1:
        return <GestionDiffuseurs />;
      default:
        return (
          <EntreprisesPartenaires
            filtreMotsCles={filtreMotsCles}
            orderPartner={orderPartner}
            isFilteringKeyword={isFilteringKeyword}
          />
        );
    }
  };

  return (
    <div className="gestion_membres">
      {props.auth.isConnected && (
        <div className="gestion_membres__container">
          <div className="gestion_membres__container__title">
            <h1 className="h1_trait_dessus">
              {props.items[props.activeIndex].label}
            </h1>
            {props.auth.isAdmin &&
              activeIndex === 0 &&
              (page1 ? (
                <BtnBlanc
                  btnAction={() => setPage1(false)}
                  btnTexte="Voir les contributeurs"
                  btnIcone={<FaEye />}
                />
              ) : (
                <BtnBlanc
                  btnIcone={<FaRegEdit />}
                  btnAction={() => setPage1(true)}
                  btnTexte="Attribuer des droits"
                />
              ))}
            {props.auth.isAdmin && activeIndex === 2 && (
              <div className="search_bar_company">
                <div className="search_company">
                  <HiSearch className="searchBar_company_icon" />
                  <InputText
                    placeholder={`Rechercher une entreprise`}
                    value={filtreMotsCles}
                    onKeyDown={(e) => {
                      if (e.key === "Enter") {
                        e.preventDefault();
                        setIsFilteringKeyword(true);
                      }
                    }}
                    onChange={(e) => {
                      setIsFilteringKeyword(false);
                      setFiltreMotsCles(e.target.value);
                    }}
                    className="searchBar_company_input"
                  />
                </div>
                <div className="order_by">
                  <Dropdown
                    value={orderPartner}
                    options={orderData}
                    onChange={(e) => setOrderPartner(e.value)}
                    placeholder="Filtrer par"
                  />
                </div>
              </div>
            )}
          </div>
          <div className="gestion_membres__container__article">
            <div className="gestion_membres__container__article__left">
              {props.auth.isAdmin &&
                buttonsNav.map((btn, index) => {
                  return (
                    <button
                      className={
                        activeIndex === index
                          ? "btn-bleu navBarGestionDroit__btn"
                          : "btn-blanc navBarGestionDroit__btn"
                      }
                      onClick={(e) => {
                        setActiveIndex(index);
                      }}
                      key={index}
                    >
                      {btn}
                    </button>
                  );
                })}
            </div>
            <div className="gestion_membres__container__article__right">
              {getComponents()}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

GestionDroits.propTypes = {
  auth: PropTypes.object,
  items: PropTypes.array,
  activeIndex: PropTypes.number,
  checked: PropTypes.bool,
  setChecked: PropTypes.func,
  admin: PropTypes.object,
  rolesFromDb: PropTypes.array,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  admin: state.admin,
});

const mapDispatchToProps = () => ({});

export default connect(mapStateToProps, mapDispatchToProps)(GestionDroits);
